import { RouteComponentProps } from "../../../../models/RouteComponent";
import useApiService from "../../../../hooks/useApiService";
import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { EmployeeListRecord } from "../../../../models/DSF/EmployeeDatabase";
import Employee from "./Employee/Employee";

function EmployeeDatabase(props: RouteComponentProps) {
  const { session, employee, setEmployee, setGlobalLoader } = props;
  const toast = useRef<any>(null);

  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeListRecord | null>(null);
  const [employeeId, setEmployeeId] = useState<string | null>(null);
  const { data, loading, error } = useApiService<EmployeeListRecord[]>({
    method: "GET",
    url: "/employee-database",
    apiName: "open",
    params: {
      clientId: session.client_id,
      siteId: session.site_id,
    },
  });

  useEffect(() => {
    setGlobalLoader(loading);
  }, [loading, setGlobalLoader]);

  useEffect(() => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load employee database",
        life: 3000,
      });
    }
  }, [error]);

  // Handle employee passed from navigation (e.g., from organogram)
  useEffect(() => {
    if (employee && data) {
      // Find the employee in the data array
      const foundEmployee = data.find(emp => emp.id === employee.id);
      if (foundEmployee) {
        setSelectedEmployee(foundEmployee);
        setEmployeeId(foundEmployee.id);

        // Clear the employee from props to prevent re-opening on subsequent visits
        if (setEmployee) {
          setEmployee(null);
        }
      }
    }
  }, [employee, data, setEmployee]);

  // console.log("data == ", data);

  const displayNameField = (data: EmployeeListRecord) => {
    return (
      <>
        {data.name} {data.surname}
      </>
    );
  };

  return (
    <>
      <Typography level="h2" component="h1">
        Employee database
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
      {data && (
        <DataTable
          value={data}
          className={"policies-procedures-table"}
          tableStyle={{ minWidth: "50rem" }}
          onRowClick={e => {
            setSelectedEmployee(e.data as EmployeeListRecord);
            setEmployeeId(e.data.id as string);
          }}
        >
          <Column field={"name"} header={"Name"} body={displayNameField} />
          <Column field={"title"} header={"Title"} />
          <Column field={"email"} header={"Email"} />
          <Column field={"mobile"} header={"Phone"} />
        </DataTable>
      )}

      {employeeId && selectedEmployee && (
        <Dialog
          onHide={() => {
            setSelectedEmployee(null);
            setEmployeeId(null);
          }}
          header={selectedEmployee?.name + " " + selectedEmployee?.surname}
          visible={!!employeeId}
          style={{ width: "60vw" }}
        >
          <Employee employeeId={employeeId} {...props} />
        </Dialog>
      )}

      <Toast ref={toast} />
    </>
  );
}

export default EmployeeDatabase;
